import './VenueClubDetailsPage.css';
import HeroSectionBox from './custom-comp/HeroSectionBox.jsx';
import MenuSection from './custom-comp/MenuSection.jsx';
import RecommendedClub from './custom-comp/RecommendedClub.jsx';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FooterTagSection from './custom-comp/FooterTagSection.js';


export default function VenueClubDetailsPage() {

  const [data, setData] = useState([]);
  const [clubId, setClubId] = useState("");
  const [longitude, setLongitude] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [recomendedClubData, setRecomendedClubData] = useState([]);

  const [partypackages, setPartypackages] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [teasers, setTeasers] = useState([]);
  const [events, setEvents] = useState([]);
  const [menus, setMenus] = useState([]);


  // const { city, area, clubname } = useParams();

  const { clubInfo } = useParams();
  const [clubname, city, area] = clubInfo?.split("-").map((str) => str.replace(/_/g, " "));



  const newApi = new FormData();
  newApi.append("city", city);
  newApi.append("area", area);
  newApi.append("club", clubname);

  useEffect(() => {
    axios
      .post("https://partywitty.com/master/APIs/Web/getClubDetails", newApi)
      .then((response) => {
        setData(response.data.data);
        setClubId(response.data.data.id);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [clubname]);

  useEffect(() => {
    if (latitude !== null && longitude !== null) {
      const ClubApi = new FormData();
      ClubApi.append("latitude", latitude);
      ClubApi.append("longitude", longitude);

      axios
        .post(
          "https://partywitty.com/master/APIs/Common/recommendedClub",
          ClubApi
        )
        .then((response) => {
          const dataArray = Object.values(response.data.data);
          setRecomendedClubData(dataArray);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [latitude, longitude]);

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLatitude(latitude);
          setLongitude(longitude);
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    } else {
      console.error("Geolocation is not available in this browser.");
    }
  }, []);


  useEffect(() => {
    if (data) {
      setPartypackages(data.party_packages || []);
      setGallery(data.gallery || []);
      setTeasers(data.teasers || []);
      setEvents(data.events || []);
      setMenus(data.club_menu || []);

    }
  }, [data]);



  const generateRelatedLinks = (clubname, city, area) => {
    // Capitalize first letter of each word
    const format = (str) =>
      str?.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

    const formattedCity = format(city).replace(" ", "-");      // Noida
    const formattedArea = format(area);      // Sector 38
    const formattedClub = format(clubname);  // F Bar

    return [
      {
        id: 1,
        url: `/venues/${formattedCity}`,
        tag: `Restaurants in ${formattedArea}`,
      },
      {
        id: 2,
        url: `/venues/${formattedCity}`,
        tag: formattedArea,
      },
      {
        id: 3,
        url: `/venues/${formattedCity}`,
        tag: `${formattedArea} Restaurants`,
      },
      {
        id: 4,
        url: `/venues/${formattedCity}`,
        tag: `${formattedArea} Restaurants in ${formattedCity}`,
      },
      {
        id: 5,
        url: `/venues/${formattedCity}`,
        tag: `${formattedCity} Restaurants`,
      },
      {
        id: 6,
        tag: `${formattedCity} Dining Options`,
      },
      {
        id: 7,
        tag: `Casual Dining in ${formattedArea}`,
      },
      {
        id: 8,
        tag: `Bar in ${formattedArea}`,
      },
      {
        id: 9,
        tag: `Bars in ${formattedCity}`,
      },
      {
        id: 10,
        tag: `${formattedClub} - ${formattedArea} - ${formattedCity}`,
      },
    ];
  };

  const relatedLinks = generateRelatedLinks(clubname, city, area);





  return (
    <div className='vcdp-section '>
      <div className='vcdp-container'>
        <HeroSectionBox data={data} />
        <div className='vcdp-content-container'>
        <MenuSection partypackages={partypackages} data={data} events={events} gallery={gallery} teasers={teasers} menus={menus} />
        <RecommendedClub recomendedClubData={recomendedClubData} />
        <FooterTagSection relatedLinks={relatedLinks} clubInfo={clubInfo} />
        </div>
      </div>
    </div>
  )
}
